import React from "react";
import { makeStyles } from '@material-ui/core/styles'; 
import SimpleMenu, { MenuItem } from "../SimpleMenu";

type ContentProps = {
  content: string;
  menuItems?: MenuItem[];
}
const useStyles = makeStyles(theme => ({
  imgWrapper: {
    overflow: 'hidden',
    gridArea: 'content',
    justifySelf: 'center',
  },
  selectedImage: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  expandedContent: {
    fontFamily: 'OpenSans',
    fontSize: '15px',
    color: '#606060',
    clear: 'both',
    overflow: 'scroll',
    overflowX: 'hidden',
    gridArea: 'content',
  },
  menu: {
    paddingTop: '1rem',
  }
}));

export const Content: React.FC<ContentProps> = ({ content, menuItems }) => {
  const classes = useStyles();
  return (
    <div className={classes.expandedContent}>
      <div
        dangerouslySetInnerHTML={{ __html: content }}
      />
      {!!menuItems?.length &&
        <div className={classes.menu}>
          <SimpleMenu title="Video Journal" menuItems={menuItems} />
        </div>}
    </div>
  );
};